<template>
	<div
		class="user-notification"
		v-on-clickaway="closeList"
	>
		<div @click="showList = !showList">
			<slot>
				<img
					src="@/assets/icons/ic-bell.svg"
					class="notif"
				>
			</slot>
		</div>

		<div class="notif-count">
			100
		</div>

		<div
			class="notification-list"
			v-if="showList"
		>
			<LoadOnScroll>
				<ul>
					<li
						v-for="n in 20"
						:key="n"
					>
						<AppImage
							:src="require('@/assets/img/default-avatar.png')"
							:fallback="require('@/assets/img/default-avatar.png')"
							title="avatar"
							class="avatar"
						/>

						<h5>
							Name Here
						</h5>

						<div class="message">
							<p>
								Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugit, excepturi?
							</p>

							<footer>
								<p>
									2019-11-28
								</p>
							</footer>
						</div>
					</li>
				</ul>
			</LoadOnScroll>
		</div>
	</div>
</template>

<script>
import LoadOnScroll from '@/components/layouts/LoadOnScroll.vue'

export default {
	data () {
		return {
			showList: false
		}
	},

	methods: {
		closeList () {
			this.showList = false
		}
	},

	components: {
		LoadOnScroll
	}
}
</script>

<style lang="scss" scoped>
.user-notification {
	position: relative;

	img.notif {
		width: 25px;
		cursor: pointer;
	}

	.notification-list {
		position: absolute;
		top: 100%;
		right: -1em;
		margin-top: 10px;
		width: 400px;
		height: 300px;
		background-color: #fff;
		z-index: 999;
		border: 1px solid $light;
		padding: 5px;

		ul {
			width: 100%;

			li {
				padding: 5px;
				margin-bottom: 10px;
				@include flex-row();

				.avatar {
					width: 40px;
					height: 40px;
					border-radius: 50%;
					flex-grow: 0;
					flex-shrink: 0;
					background-size: 'cover';
				}

				h5 {
					width: 150px;
					font-weight: 600;
					margin: 5px 10px;
					flex-grow: 0;
				}

				.message {
					flex: 1 1 auto;

					p {
						font-size: .8em;
					}

					footer {
						text-align: right;
						color: $dark;
					}
				}

			}
		}

		&:after {
			position: absolute;
			content: "";
			right: 2.25em;
			top: -6px;
			border: 1px solid;
			border-color: $light  $light transparent transparent;
			display:inline-block;
			height: 10px;
			width: 10px;
			background-color: #fff;
			transform: rotateZ(-45deg);
			pointer-events: none;
			z-index: 999;
		}
	}

	.notif-count {
		position: absolute;
		top: -10px;
		right: -10px;
		z-index: 2;
		background-color: $primary;
		color: #fff;
		border-radius: 50%;
		width: 25px;
		height: 25px;
		font-size: .8em;
		@include flex-row(center, center);
		display: none;
	}
}
</style>
